const _voislogCorePath = import.meta.env.VITE_APP_VOISLOG_CORE_URL;
const _vManagementPath = import.meta.env.VITE_APP_VOISLOG_VMANAGEMENT_URL;
const _webdkMigrationPath = import.meta.env.VITE_APP_WEBDK_MIGRATION_URL;

const _voislogPaths = {
  glogin: "auth/google/token",
  login: "auth/token",
  /* eslint-disable sonarjs/no-hardcoded-passwords */
  register_user_request: "auth/register/request",
  register_user: "auth/register/verify/{request_id}",
  register_user_without_authentication: "companies/{company_id}/users",
  password_reset: "auth/password-reset/request",
  password_reset_verify: "auth/password-reset/verify/{verification_id}",
  password: "auth/users/me/password",
  /* eslint-disable sonarjs/no-hardcoded-passwords */
  info_user_employee2: "users/me",
  info_salesagent_voislog: "partners",
  detail_salesagent: "partners/{partner_id}",
  info_company: "companies",
  info_companies_in_partner: "partners/{partner_id}/companies",
  detail_company: "companies/{company_id}",
  info_department: "companies/{company_id}/departments",
  detail_department: "companies/{company_id}/departments/{department_id}",
  info_user_department: "companies/{company_id}/users/{user_id}/departments",
  info_employee: "users",
  info_users_in_company: "companies/{company_id}/users",
  invitation_user: "companies/{company_id}/users/invitation",
  verify_invitation:
    "companies/{company_id}/users/invitation/verify/{request_id}",
  info_users: "users",
  detail_user: "users/{user_id}",
  detail_user_in_company: "companies/{company_id}/users/{user_id}",
  info_partner_contract: "partner-contracts",
  detail_partner_contract: "partner-contracts/{partner_contract_id}",
  info_company_contract: "company-contracts",
  detail_company_contract: "company-contracts/{company_contract_id}",
  info_graph_employee: "analysis/mi1/list",
  mi1_list_all: "analysis/mi1/list_all/stream",
  mi1_list_aggregate: "analysis/mi1/aggregate/grouped",
  user_cog: "analysis/cog/list",
  cog_list_all: "analysis/cog/list_all/stream",
  user_np1: "analysis/np1/list",
  np1_list_all: "analysis/np1/list_all/stream",
  user_co1: "analysis/co1/list",
  co1_list_all: "analysis/co1/list_all/stream",
  user_co2: "analysis/co2.1/list",
  co2_list_all: "analysis/co2.1/list_all/stream",
  user_mi2: "analysis/mi2/list",
  user_mi2_all: "analysis/mi2/list_all",
  user_mi2_1: "analysis/mi2.1/list",
  user_mi2_1_all: "analysis/mi2.1/list_all/stream",
  user_sl1: "analysis/sl1/list",
  sl1_list_all: "analysis/sl1/list_all/stream",
  user_br1: "analysis/br1/list",
  br1_list_all: "analysis/br1/list_all/stream",
  user_email: "auth/users/{user_id_or_me}/email-change/request",
  roles: "companies/{company_id}/users/{user_id}/roles",
  policies: "policies/{policy_type}",
  policies_latest: "policies/latest",
  policies_agreement: "policies/users/me/agreements",
  detail_verifications: "verifications/{verification_id}",
  company_owner: "companies/{company_id}/owner",
  user_in_company_email: "companies/{company_id}/users/{user_id}/email",
  external_viewer: "companies/{company_id}/external-viewers",
  detail_external_viewer: "companies/{company_id}/external-viewers/{user_id}",
  external_viewer_invitation:
    "companies/{company_id}/external-viewers/invitations",
  approve_external_viewer_invitation:
    "companies/{company_id}/external-viewers/invitations/verify/{verification_id}",
  user_email_change: "auth/email-change/verify/{request_id}",
  detail_pst: "pst/{user_id}",
  request_unlock: "auth/unlock/request",
  alert_setting: "notifications/mail/alert-setting",
  viewer_alert_setting: "notifications/mail/viewer-alert-setting",
  external_viewer_alert_setting:
    "companies/{company_id}/external-viewers/{user_id}/alert-settings",
  reminder_setting: "notifications/mail/reminder-setting",
  app_setting_phrase: "app_settings/v_analysis/phrase",
  mail_template_alert: "notifications/mail/template/alert",
  send_test_mail_alert: "notifications/mail/template/alert/test",
  analytics_daily: "analytics/daily",
  analytics_monthly: "analytics/distribution/monthly",
  analytics_hourly: "analytics/distribution/hourly",
  analytics_weekday: "analytics/distribution/weekday",
  report_setting: "notifications/mail/report-setting",
  email_delivery_setting: "notifications/mail/email-delivery-setting",
  monthly_report_all: "report/monthly/all",
  notifications_history_list: "notifications/history/list",
  notifications_history_list_all: "notifications/history/list_all",
  reminder_list: "reminder_hists/list",
  reminder_list_all: "reminder_hists/list_all",
  activities_summary: "analysis/activities/summary",
  activities_summary_all: "analysis/activities/summary_all",
  viewer_access_restrictions:
    "companies/{company_id}/viewers/{user_id}/access-restrictions",
  external_viewer_access_restrictions:
    "companies/{company_id}/external-viewers/{user_id}/access-restrictions",
};

const _vmanagementPaths = {
  info_salesagent: "partners",
  import_users_csv: "register/import",
  info_pricemodel: "plans",
  detail_pricemodel: "plans/{plan_id}",
  app_label_settings: "settings/app_label",
  allow_override_settings: "app_settings/allow_override",
  app_setting_rec_type: "app_settings/rec_type",
  app_setting_phrase: "app_settings/phrase",
  app_setting_mi1: "app_settings/mi1",
  info_company: "companies",
  info_graph_company: "analysis/mi1/average/list",
  info_frequency_distribution: "analysis/mi1/frequency/list",
  csv_company: "analysis/mi1/list/export",
  csv_department: "analysis/mi1/average/export",
  csv_frequency: "analysis/mi1/frequency/export",
  csv_employee: "analysis/mi1/export",
  user_co1_csv: "analysis/co1/export",
  co1_list_csv: "analysis/co1/list/export",
  user_co2_csv: "analysis/co2.1/export",
  co2_list_csv: "analysis/co2.1/list/export",
  user_mi2_csv: "analysis/mi2/export",
  mi2_list_csv: "analysis/mi2/list/export",
  user_mi2_1_csv: "analysis/mi2.1/export",
  mi2_1_list_csv: "analysis/mi2.1/list/export",
  user_br1_csv: "analysis/br1/export",
  br1_list_csv: "analysis/br1/list/export",
  user_sl1_csv: "analysis/sl1/export",
  sl1_list_csv: "analysis/sl1/list/export",
  mi1_statistics_count: "analysis/mi1/statistics/count",
  analysis_trend_all: "trend/analysis/all",
  partners_trend_all: "trend/partners/all",
  companies_trend_all: "trend/companies/all",
  employees_trend_all: "trend/users/all",
  info_employee: "users",
  info_department: "companies/{company_id}/departments",
  banner_setting: "app_settings/image/banner",
  splash_setting: "app_settings/image/splash",
  mail_template_alert_all: "notifications/mail/template/alert/all",
  mi1_list_latest: "analysis/mi1/latest",
  viewer_setting_errors: "viewer-setting-errors",
};

const _webdkMigrationPaths = {
  import_analysis_data: "analysis/import",
};

export default {
  methods: {
    getVoislogURL(param) {
      return _voislogCorePath + _voislogPaths[param];
    },
    getVoislogVmanagementURL(param) {
      return _vManagementPath + _vmanagementPaths[param];
    },
    getWebDKMigrationURL(param) {
      return _webdkMigrationPath + _webdkMigrationPaths[param];
    },
  },
};
